export const iconFontAwesomeSportsFitnessFutbol = (
	<i className="fa-solid fa-futbol"></i>
);
